import type { Theme, PaletteMode } from '@mui/material';
import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { themeBase } from './theme.base';
import { themeComponents } from './components';

const theme = (mode: PaletteMode): Theme => {
  const base = themeBase(mode);
  const components = themeComponents(mode);

  const merged = deepmerge(base, {
    components,
  });

  const finalTheme = createTheme(merged);

  return finalTheme;
};

export default theme;
